import { combineReducers } from 'redux'
import filter from './filter'
import date from './date'

export default combineReducers({
  filter,
  date,
})
